// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---gu5yq","changedRecordsList":"changedRecordsList---oqWij","changedRecord":"changedRecord---qLLVP"};